export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25')
];

export const server_loads = [];

export const dictionary = {
		"/": [6],
		"/(admin)/agents": [7,[2]],
		"/(admin)/agents/[agent]": [8,[2,3]],
		"/(admin)/agents/[agent]/agent": [9,[2,3]],
		"/(admin)/agents/[agent]/feeds": [10,[2,3]],
		"/(admin)/agents/[agent]/manifesto": [11,[2,3]],
		"/(admin)/agents/[agent]/narratives": [12,[2,3]],
		"/(admin)/agents/[agent]/prompts": [13,[2,3]],
		"/(admin)/agents/[agent]/sources": [14,[2,3]],
		"/(admin)/agents/[agent]/training": [15,[2,3]],
		"/(admin)/dashboard": [16,[2]],
		"/(admin)/library": [17,[2]],
		"/(admin)/news": [18,[2,4]],
		"/(admin)/news/[agent]": [19,[2,4]],
		"/(admin)/news/[agent]/[id]": [20,[2,4]],
		"/(admin)/sources": [21,[2]],
		"/(admin)/system": [22,[2,5]],
		"/(admin)/system/prompts": [23,[2,5]],
		"/(admin)/system/status": [24,[2,5]],
		"/(admin)/system/users": [25,[2,5]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';